import React, { useEffect, useState, useContext } from "react";

import { AuthContext } from "../../shared/context/auth-context";
import Card from "../../shared/components/UIElements/Card";
import InstrumentItem from "./InstrumentItem";
// import "./InstrumentList.css";

const InstrumentList = ({ loadedData }) => {

  const [sortConfig, setSortConfig] = useState({ key: "TAS", direction: "desc" });
  const [activeColumn, setActiveColumn] = useState("TAS");

  const sortedInstruments = [...loadedData.instruments].sort((a, b) => {
    if (sortConfig.key) {
      let aValue, bValue;

      // Check if sorting key is nested within `trades_summary`
      if (sortConfig.key.startsWith("trades_summary.")) {
        const nestedKey = sortConfig.key.split(".")[1];
        aValue = a.trades_summary ? a.trades_summary[nestedKey] : 0;
        bValue = b.trades_summary ? b.trades_summary[nestedKey] : 0;
      } else {
        // For non-nested keys
        aValue = a[sortConfig.key];
        bValue = b[sortConfig.key];
      }

      // Convert values to numbers if they are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      // Compare values based on sort direction
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Function to update sort configuration
  const handleSort = (columnKey) => {
    let direction = "desc";
    if (
      sortConfig.key === columnKey &&
      sortConfig.direction === "desc"
    ) {
      direction = "asc";
    }
    setSortConfig({ key: columnKey, direction });
    setActiveColumn(columnKey);
  };

  return (
    <React.Fragment>
      <Card className="instrument-list-header">
        <table>
          <thead>
            <tr>
              <th onClick={() => handleSort("Date")} className={activeColumn === "Date" ? "active" : ""}>DATE</th>
              <th onClick={() => handleSort("title")} className={activeColumn === "title" ? "active" : ""}>NAME</th>
              <th onClick={() => handleSort("ticker")} className={activeColumn === "ticker" ? "active" : ""}>TICKER</th>
              <th onClick={() => handleSort("RSI")} className={activeColumn === "RSI" ? "active" : ""}>RSI</th>
              {/* <th onClick={() => handleSort("MACD")} className={activeColumn === "MACD" ? "active" : ""}>MACD</th> */}
              {/* <th onClick={() => handleSort("VIX")} className={activeColumn === "VIX" ? "active" : ""}>VIX</th> */}
              <th onClick={() => handleSort("Close")} className={activeColumn === "Close" ? "active" : ""}>PRICE [USD]</th>
              <th onClick={() => handleSort("SIGNAL")} className={activeColumn === "SIGNAL" ? "active" : ""}>SIGNAL</th>
              <th onClick={() => handleSort("TRADE")} className={activeColumn === "TRADE" ? "active" : ""}>TRADE ON</th>
              <th onClick={() => handleSort("trades_summary.PNL_PER_AVG")} className={activeColumn === "trades_summary.PNL_PER_AVG" ? "active" : ""}>Ø PROFIT [%]</th>
              <th onClick={() => handleSort("trades_summary.NUMBER_OF_TRADES")} className={activeColumn === "trades_summary.NUMBER_OF_TRADES" ? "active" : ""}>TRADES</th>
              <th onClick={() => handleSort("trades_summary.HOLD_PER_AVG")} className={activeColumn === "trades_summary.HOLD_PER_AVG" ? "active" : ""}>HOLD DUR [d]</th>
              {/* <th onClick={() => handleSort("trades_summary.MAX_MDD")} className={activeColumn === "trades_summary.MAX_MDD" ? "active" : ""}>MDD [%]</th> */}
              <th onClick={() => handleSort("TAS")} className={activeColumn === "TAS" ? "active" : ""}>TAS [-]</th>
            </tr>
          </thead>
        </table>
      </Card>
      <div>
        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
          {sortedInstruments.map((instrument, index) => (
            <InstrumentItem
              key={instrument._id}
              id={instrument._id}
              id2={index}
              date={instrument.Date}
              title={instrument.title}
              ticker={instrument.ticker}
              RSI={instrument.RSI}
              // MACD={instrument.MACD}
              // VIX={instrument.VIX}
              closingPrice={instrument.Close}
              // USD, or the quote currency where control has no USD rate
              priceCurrency={instrument.priceCurrency}
              signal={instrument.SIGNAL}
              trade={instrument.TRADE}
              pnl_per_avg={
                instrument.trades_summary
                  ? Number(instrument.trades_summary.PNL_PER_AVG).toFixed(2)
                  : "NaN"
              }
              trade_number={
                instrument.trades_summary
                  ? Number(instrument.trades_summary.NUMBER_OF_TRADES).toFixed(
                      0
                    )
                  : "NaN"
              }
              avg_hold_per={
                instrument.trades_summary
                  ? Number(instrument.trades_summary.HOLD_PER_AVG).toFixed(0)
                  : "NaN"
              }
              // max_mdd={
              //   instrument.trades_summary
              //     ? Number(instrument.trades_summary.MAX_MDD).toFixed(2)
              //     : "NaN"
              // }
              tas={instrument.TAS}
            />
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default InstrumentList;
